import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/layer/category/layer/add/many/layer.category.layer.add.many.mutation.gql"
import type {
  LayerCategoryLayerAddManyMutation,
  LayerCategoryLayerAddManyMutationVariables,
} from "@/v2-backoffice-client/layer/category/layer/add/many/__types__/layer.category.layer.add.many.mutation"

type Options = MutationHookOptions<
  LayerCategoryLayerAddManyMutation,
  LayerCategoryLayerAddManyMutationVariables
>

export function useLayerCategoryLayerAddManyMutation(options?: Options) {
  return useMutation<
    LayerCategoryLayerAddManyMutation,
    LayerCategoryLayerAddManyMutationVariables
  >(mutation, options)
}
